/** Keep in sync with netlify/functions/lib/gcs.js ARTIFACTS.ext */
const ARTIFACT_EXTS = {
  tracker: "jpeg",
  zip: "zip",
  glb: "glb",
  usdz: "usdz",
  thumbnail: "png",
};

export function projectNameOf(project) {
  return project?.slug || project?.title || project?.id || "";
}

export function artifactFilename(projectName, artifact) {
  const ext = ARTIFACT_EXTS[artifact];
  if (!ext) throw new Error(`Unknown artifact: ${artifact}`);
  if (!projectName) throw new Error("projectName is required");
  return `${projectName}.${ext}`;
}

/** users/{username}/{projectName}/ */
export function gcsPrefix(username, projectName) {
  if (!username || !projectName) return null;
  return `users/${username}/${projectName}/`;
}

/**
 * Share URL for WebAR players.
 * Image → xr1, world → xr2.
 * Params: ?u={username}&p={projectName} (projectName = slug).
 */
export function webArUrl(project) {
  const host =
    project.tracking_type === "world"
      ? "https://xr2.argon-web.io"
      : "https://xr1.argon-web.io";
  const u = project.username || project.user_id;
  const p = projectNameOf(project);
  return `${host}/?u=${encodeURIComponent(u)}&p=${encodeURIComponent(p)}`;
}
